import jQuery from 'jquery';
import axios from '../utils/axios';
import loader from './loader';
import _forEach from 'lodash/forEach';

(function($) {
    const body = $('body');
    const shopSelectModal = $('#shopSelectModal');
    const runtimeChangeModal = $('#runtimeChangeModal');
    const redirect = shopSelectModal.find('form #redirect');
    const selectedValue = shopSelectModal.find('form #selectedValue');

    /**
     *
     * @param {String} changed
     * @param {String} value
     * @param {boolean} confirmed
     */
    const load = function (changed, value, confirmed = false) {
        axios.get(window.config.urls.tenantSwitch, { params: {
                [changed]: value,
                url: window.config.full,
                confirmed: confirmed
        }}).then(({data}) => {
            switch (data.action) {
                case 'setRuntime':
                    setRuntime(data);
                    break;
                case 'runtimeChangeModal':
                    showRuntimeChangeModal(data);
                    break;
                case 'shopSelectModal':
                    showShopSelectModal(data);
                    break;
            }
        }).catch((a,b,c,d,e) => {
            // TODO report selection is not valid
        })
    }

    function setRuntime(data) {
        loader(true);
        window.location.href = data.url;
    }

    function showRuntimeChangeModal(data) {
        let droppedItemsHtml = '';
        _forEach(data.dropped_items, (item) => {
            droppedItemsHtml += '<li class="border-bottom py-1">' + item.name + '</li>';
        });

        runtimeChangeModal.find('#runtimeChangeModalContent').html(droppedItemsHtml);
        runtimeChangeModal.find('input[name="key"]').val(data.key);
        runtimeChangeModal.find('input[name="value"]').val(data.value);
        runtimeChangeModal.modal('show');
    }

    function showShopSelectModal(data) {
        function templateStringForTenant(tenant) {
            let label = [
                (data.show.country ? tenant.countryName : ''),
                (data.show.language ? tenant.languageName : ''),
                (data.show.currency ? tenant.currencyName : ''),
            ].filter((el) => !!el).join(' ');

            let templateString = '<li class=""  tabindex="0" data-value="' + tenant.value +'" data-url="' + tenant.url + '" aria-label="' + label + '">';

            let text = [
                (data.show.country ? (data.show.countryFlag ? '<span class="flag-icon flag-icon-' + tenant.country.toLowerCase() + '"></span>' : '') + '<span>' + tenant.countryName + '</span>' : ''),
                (data.show.language ? (data.show.languageFlag ? '<span class="flag-icon flag-icon-' + tenant.languageFlag.toLowerCase() + '"></span>' : '') + '<span>' + tenant.languageName + '</span>' : ''),
                (data.show.currency ? '<span>' + tenant.currencyName + '</span>' : ''),
            ].filter((el) => !!el).join(' <span class="divider"></span> ');

            templateString += text;

            return templateString + '<i class="is-shop-select-list__check fal fa-check"></i></li>';
        }

        let tenants = data.tenants;
        let title = data.title;
        let template = '';
        let count = 0;
        let tenant = null;
        let tenantsLength = tenants.length;

        if (tenantsLength > 1) {
            let rows = parseInt(tenantsLength) / 2;

            template += '<ul class="is-shop-select-list">';
            for (let step = 0; step < rows; step++, count++) {
                tenant = tenants[step];
                template += templateStringForTenant(tenant);
            }
            template += '</ul>';

            template += '<ul class="is-shop-select-list">';
            for (let step = count; step < tenantsLength; step++) {
                tenant = tenants[step];
                template += templateStringForTenant(tenant);
            }
            template += '</ul>';
        } else {
            template += '<ul class="is-shop-select-list">';
            for (let step = 0; step < tenantsLength; step++) {
                tenant = tenants[step];
                template += templateStringForTenant(tenant);
            }
            template += '</ul>';
        }

        shopSelectModal.find('.shopSelectModalLabel').html(title);
        shopSelectModal.find('.select-list-for-languages').html(template);
        shopSelectModal.modal('show');
    }

    function selectTenant() {
        shopSelectModal.modal('hide');

        const active = $('.is-shop-select-list > li.active').first();

        if (active.data('value')) {
            loader(true);
            shopSelectModal.find('form').submit();
            return
        }

        window.location.href = active.data('url');
    }

    function shopSelectListItemModalClickListener(event) {
        if(event.type === 'click') {
            return true;
        } else if(event.type === 'keyup') {
            const code = event.charCode || event.keyCode;

            if((code === 32) || (code === 13)){
                return true;
            }
        } else {
            return false;
        }
    }

    $(document).ready(function() {
        $('.dropdown.shop-selector li>a').click(function(event) {
            event.preventDefault();
            event.stopPropagation();

            const me = $(this);
            load(me.data('name'), me.data('value'));
        })
        body.on('click keyup', '.is-shop-select-list > li', function (event) {
            if(shopSelectListItemModalClickListener(event) === true) {
                const me = $(this);
                /** submit selected language **/
                if(me.hasClass('active')) {
                    selectTenant();
                }

                $('.is-shop-select-list > li').removeClass('active');
                me.addClass('active');

                selectedValue.val(me.data('value'));
                redirect.val(me.data('url'));
            }
        }).on('click', '.save-new-tenant', function (event) {
            selectTenant();
        }).on('click', '#changeRuntime', function (event) {
            load(
                runtimeChangeModal.find('input[name="key"]').val(),
                runtimeChangeModal.find('input[name="value"]').val(),
                true
            );
        });
    });
})(jQuery);
